// Session Time is currently unused; appsettings.json CookieSettings.ExpireTime controls cookie expiration.
// TODO: Decide whether to remove the setting (losing runtime configuration) or apply it at startup
// instead of CookieSettings.ExpireTime.

import { SettingsSectionsName } from "../settings-sections-name";
import { SystemConfigurationResolveData } from "../system-configuration-resolve-data";

export class SessionTimeSettings {
    sessionTimeMinutes: number;

    static parse(data: SystemConfigurationResolveData): SessionTimeSettings {
        return data.getConfigSection<SessionTimeSettings>(SettingsSectionsName.SessionTimeSettings);
    }
}